import React from 'react';
import InitializeRouter from './InitializeRouter';
import InitializeApp from './InitializeApp';
import InitializePage from './InitializePage';

export const App = props => (
  <InitializeApp>
    <InitializePage>
      <InitializeRouter {...props} />
    </InitializePage>
  </InitializeApp>
);
